import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'focus-visible';
import 'assets/scss/app.scss';
import '@huggg/react-components/build/index.css';
import App from 'components/App/App';
import React from 'react';
import ReactDOM from 'react-dom';
import AuthService from 'services/AuthService';

new AuthService();

ReactDOM.render(<App />, document.getElementById('root'));
